var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Nie znaleziono strony")]),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.back($event)}}},[_vm._v("Cofnij")])])}
var staticRenderFns = []

export { render, staticRenderFns }